export class Product {
    public productSku: string;
    public productName: string;
    public productUrl: string;
    public productId: string;
    public donation: number;
    public isEditable: boolean = false;
  }